<template>
    <div class="c-m-testimonial">
        <div class="c-m-testimonial__avatar">
            <img
                v-if="testimonial.profile_picture"
                class="c-m-testimonial__picture"
                :srcset="`${testimonial.profile_picture.sizes.thumbnail} 150w`"
                :sizes="'(max-width: 150) 150px'"
                :src="testimonial.profile_picture.sizes.thumbnail"
                :alt="testimonial.profile_picture.alt">
            <icon v-else class="c-m-testimonial__icon" :icon="'person'"></icon>
        </div>
        <div class="c-m-testimonial__body">
            <p class="c-m-testimonial__quote h3">”{{ testimonial.quote }}”</p>
            <p class="c-m-testimonial__byline">{{ testimonial.byline }}</p>
        </div>
    </div>
</template>

<script>
    import Icon from '../atoms/AtomIcon.vue';

    export default {
        props: [
            'testimonial'
        ],
        components: {
            Icon
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeTestimonial.vue